import axios from 'axios';
import config from '../../config';
import { saveAs } from 'file-saver';

const baseUrl = config.baseUrl;

// Endpoints
const endpoint1 = '/api/proyectosPO';
const endpoint2 = '/api/componentesPO';
const endpoint3 = '/api/serviciomenuPOA';
const endpoint4 = '/api/dashboard-poa';
const endpoint5 = '/api/filesmi';
const endpoint6 = '/api/downloadAllSoportes';
const endpoint7 = '/api/poaPPBuscar';

// Obtener proyectos PO
const getProyectosPO = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint1}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los proyectos:', error);
    throw error;
  }
};

// Obtener componentes PO
const getComponentesPO = async (codigo_proyecto) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint2}`, {
      params: { codigo_proyecto },
    });
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los componentes:', error);
    throw error;
  }
};

// Obtener datos del proyecto
const getDataProyectos = async (codigo_proyecto) => {
  if (!codigo_proyecto) {
    console.warn("El código de proyecto es inválido o no fue proporcionado.");
    return { status: 400, data: [] };
  }

  try {
    const oid_proyecto = { codigo_proyecto };
    const response = await axios.get(`${baseUrl}${endpoint3}/${codigo_proyecto}`, {
      params: { oid_proyecto },
    });
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al obtener los componentes:", error);
    return { status: 500, data: [] };
  }
};

// Obtener indicadores del dashboard
const dataIndicadores = async (codigo_proyecto) => {
  if (!codigo_proyecto) {
    console.warn("El código de proyecto es inválido o no fue proporcionado.");
    return { status: 400, data: [] };
  }

  try {
    const body = JSON.stringify({ proyecto: codigo_proyecto });
    const response = await axios.post(`${baseUrl}${endpoint4}`, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al obtener los indicadores:", error);
    return { status: 500, data: [] };
  }
};

// Obtener archivos MI
const getFilesMI = async (codigo_proyecto) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint5}`, {
      params: { codigo_proyecto },
    });
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error('Error al obtener los archivos MI:', error);
    throw error;
  }
};

// Descargar todos los soportes (ZIP)
const descargaSoportes = async (proyecto, ruta) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint6}`, {
      params: { proyecto, ruta },
      responseType: 'blob',
    });

    const fileName = `${proyecto}_soportes_manifestaciones_interes.zip`;
    saveAs(response.data, fileName);
  } catch (error) {
    console.error('Error descargando soportes:', error);
    throw error;
  }
};

// Eliminar archivo MI
const deleteFileMI = async (oid, user) => {
  return axios.delete(`${baseUrl}${endpoint5}/${oid}`, {
    data: { user }  
  });
};

const getDirectoryTreePoaPP = async (proyecto, codigo_tarea) => {
  if (!proyecto || !codigo_tarea) {
    console.warn("Los parámetros 'proyecto' y 'codigo_tarea' son obligatorios.");
    return { status: 400, data: [] };
  }

  try {
    const response = await axios.get(`${baseUrl}${endpoint7}`, {

      params: { proyecto, codigo_tarea },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error al obtener los datos del árbol POA:", error);
    return { status: 500, data: [] };
  }
};

// Exportar funciones
export {
  getProyectosPO,
  getComponentesPO,
  getDataProyectos,
  dataIndicadores,
  getFilesMI,
  descargaSoportes,
  deleteFileMI,
  getDirectoryTreePoaPP,
};
